
import { defineComponent, reactive } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";

export default defineComponent({
  name: "notif-unsubscribe",
  setup() {
    const route = useRoute();
    const ticRef = String(route.params.ticRef || "");
    const state = reactive({
      loading: false,
      submitted: false,
      ok: false,
      email: "",
    });

    const submitUnsubscribe = async () => {
      if (!ticRef || !state.email.trim()) {
        return;
      }
      state.loading = true;
      try {
        const baseUrl = process.env.VUE_APP_BACK_URL || "";
        const response = await axios.post(
          `${baseUrl}/unsubscribeNotifTicket`,
          {
            tic_ref: ticRef,
            email: state.email.trim(),
          },
          { withCredentials: true }
        );
        const result = response.data?.results || response.data;
        state.ok = result?.ok === true || result?.ok === 1 || result?.ok === '1';
        state.submitted = true;
      } catch {
        state.ok = false;
        state.submitted = true;
      } finally {
        state.loading = false;
      }
    };

    return { state, submitUnsubscribe };
  },
});
